import { PARSIVE_ENABLED, PARSIVE_API_KEY, PARSIVE_WIDGET_ID } from "../settings/config";

// Let TypeScript know about the global the widget exposes. One object carries
// both the context this app writes and the methods the widget provides, so
// there is a single name to remember and no capitalisation to get wrong.
declare global {
    interface Window {
        parsive?: {
            context?: Record<string, unknown>;
            start?: (options?: { apiKey?: string; widgetId?: string }) => void;
            stop?: () => void;
        };
    }
}

// Turn the widget ON. Returns a function that turns it OFF again.
export const startParsiveWidget = (): (() => void) => {
    if (!PARSIVE_ENABLED || !PARSIVE_API_KEY || !PARSIVE_WIDGET_ID) {
        return () => {};
    }

    window.parsive?.start?.({ apiKey: PARSIVE_API_KEY, widgetId: PARSIVE_WIDGET_ID });

    return () => window.parsive?.stop?.();
};
